import backendService from './backend';

/**
 *
 * @param {{ carouselId: string, signal?: AbortSignal }} options
 * @returns {Promise<object|null>} `response.data` ou null em skip / erro.
 */
export async function getCommunicationCarousel(options) {
  const { carouselId: rawId } = options || {};
  const carouselId = String(rawId || '').trim();

  if (!carouselId) {
    return null;
  }

  try {
    const response = await backendService.layout.v4.getCarouselCommunication(carouselId);
    return response?.data ?? null;
  } catch (error) {
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.error('[communicationCarousel]', error);
    }
    return null;
  }
}

/**
 * Uma requisição por id distinto; ordem do array de retorno = ordem dos ids únicos.
 * @param {string[]} carouselIds
 * @returns {Promise<(object|null)[]>}
 */
export async function getCommunicationCarousels(carouselIds) {
  const raw = Array.isArray(carouselIds) ? carouselIds : [];
  const seen = new Set();
  const ids = [];
  for (const item of raw) {
    const id = String(item ?? '').trim();
    if (id && !seen.has(id)) {
      seen.add(id);
      ids.push(id);
    }
  }
  if (ids.length === 0) {
    return [];
  }
  return Promise.all(
    ids.map((id) => getCommunicationCarousel({ carouselId: id })),
  );
}
